import { useMutation } from '@apollo/client';

import { DeleteCatalogItemInput } from '__generated__/GQL';
import { CatalogItemsDocument } from 'features/Work/hooks/useCatalogItemsQuery/graphql/catalogItems.gql';

import { DeleteCatalogItemDocument } from './graphql/deleteCatalogItem.gql';

const useDeleteCatalogItemMutation = () => {
  const [mutation, hook] = useMutation(DeleteCatalogItemDocument);

  const deleteCatalogItem = (input: DeleteCatalogItemInput) =>
    mutation({
      awaitRefetchQueries: true,
      refetchQueries: [CatalogItemsDocument],
      variables: {
        input,
      },
    });

  return [deleteCatalogItem, hook] as const;
};

export default useDeleteCatalogItemMutation;
